<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-share-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h6>点击复制</h6>
                <div class="dialog-body">
                    <div class="share-text" v-if="shareTxt">{{ shareTxt }}</div>
                </div>

                <button class="u-btn copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt" @click="copy"></button>      
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            shareTxt : '加载中……',
            gid : '',
        }
    },
    created (){
        if(!this.$store.state.login){
            return this.$mslogin.open();
        }
        if(!this.$store.state.userinfo){
            this.$bind_modal();
            return this.$toast('请先选择大区');
        }

        this.render();
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render() {
            var _this = this;
            this.$axios.post(this.$ajax_url_map.share,this.$qs.stringify({
                id: _this.gid,
                r : +new Date(),               
            }))
            .then(res => {
                _this.shareTxt = res.data.content ? res.data.content : ('【阿斗赶集】打野队友弃我！梦三大陆逐我！甚至反补我！重生一世，今天是阿斗赶集，谁帮我砍价？' + _this.$global.domain + '?key=' + res.data.key)
            },rej => {
                _this.$toast('请稍后再试')
                _this.shareTxt = '请稍后再试'
            });
        },       
    },
}
</script>

<style scoped>
/* share */
.m-share-modal {
    width: 519px;
    height: 390px;
    background-image: url(~@/assets/images/utils/modal-copy.png);
}

.m-share-modal h6 {
    /* height: 14px; */
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
}

.m-share-modal .share-text {
    padding: 0 45px;
    word-break: break-all;
}

.m-share-modal .u-btn.copy {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 274px;
    height: 74px;
    margin-left: -137px;
    background-image: url(~@/assets/images/utils/btn-copy.png);
}
</style>


// WEBPACK FOOTER //
// src/components/ShareModal/shareModal.vue